import { supabase } from '@/integrations/supabase/client';
import type { VocabularyItem } from '@/hooks/useOfflineVocabulary';

export const VOCABULARY_PAGE_SIZE = 1000;

/**
 * RFC 162: the single server reader for a user's full vocabulary library.
 * Paginates past the 1,000-row API cap and returns only a COMPLETE snapshot —
 * any page failure or cancellation throws, so a partial result is never
 * published or cached.
 */
export async function fetchAllVocabulary(userId: string, signal?: AbortSignal): Promise<VocabularyItem[]> {
  const all: VocabularyItem[] = [];
  for (let from = 0; ; from += VOCABULARY_PAGE_SIZE) {
    if (signal?.aborted) throw new DOMException('Read cancelled', 'AbortError');
    let query = supabase
      .from('vocabulary')
      .select('*')
      .eq('user_id', userId)
      .order('created_at', { ascending: false })
      .order('id', { ascending: true }) // stable order so pages never skip/duplicate rows
      .range(from, from + VOCABULARY_PAGE_SIZE - 1);
    if (signal) query = query.abortSignal(signal);
    const { data, error } = await query;
    if (error) throw error;
    const page = (data || []) as VocabularyItem[];
    all.push(...page);
    if (page.length < VOCABULARY_PAGE_SIZE) return all;
  }
}
